import replaceWithMarkup from "../utils/replaceWithMarkup";

/**
 *
 * Loads taxonomy posts on Load More button click ( such as category archive posts )
 *
 * @param morePostsTrigger          Query string for triggering the loading and markup of posts.
 * @param elToReplaceWithPosts      Query string for node that new posts will replace.
 * @param taxonomy                  Name of the taxonomy
 * @param taxonomyTerm              Taxonomy term.
 * @param page                      Pagination index.
 */
export default function getTaxPostMarkupByTermId( morePostsTrigger, elToReplaceWithPosts, taxonomy, taxonomyTerm, page, categoryName = null ) {
    // Retry mechanism if button not found immediately (for deferred scripts)
    const tryInitialize = (attempt = 0) => {
        const trigger = document.querySelector( morePostsTrigger );
        if (!trigger && attempt < 5) {
            setTimeout(() => tryInitialize(attempt + 1), 100);
            return;
        }
        
        if (!trigger) {
            console.error(`Element not found for selector: ${morePostsTrigger} after ${attempt} attempts`);
            return;
        }
        
        // Find the anchor tag inside the trigger
        const anchor = trigger.querySelector( 'a' );
        if ( !anchor ) {
            console.error('No anchor tag found in load more button');
            return;
        }
        
        // Check if listener is already attached to this specific anchor
        if ( anchor.hasAttribute('data-listener-attached') ) {
            return; // Already initialized
        }
        anchor.setAttribute('data-listener-attached', 'true');
        
        // Attach listener to the anchor to prevent navigation
        // Also set href to javascript:void(0) to prevent navigation as backup
        if ( anchor.href === '#' || anchor.getAttribute('href') === '#' ) {
            anchor.href = 'javascript:void(0)';
        }
        
        anchor.addEventListener( 'click', function( e ) {
            e.preventDefault();

            const btnOriginalHtml = anchor.innerHTML;
            anchor.innerHTML = '<div class="la-ball-pulse la-dark la-sm"><div></div><div></div><div></div></div>';

            getTaxonomyPostMarkupApiCall( taxonomy, taxonomyTerm, page, categoryName )
                .then( res => {
                    anchor.innerHTML = btnOriginalHtml;
                    
                    if ( !res || !Array.isArray( res.posts ) || res.posts.length === 0 ) {
                        if ( res?.is_last_page ) {
                            trigger.remove();
                        }
                        return;
                    }
                    
                    const isContributorPage = document.querySelector('.contributor-archive');
                    const markup = isContributorPage 
                        ? res.posts.join('')
                        : res.posts.reduce( (preVal, currVal) => `${preVal}<li class="list-group-item">${currVal}</li>`, '' );

                    replaceWithMarkup( trigger, markup, elToReplaceWithPosts, !res.is_last_page );

                    if ( !res.is_last_page ) {
                        setTimeout(() => {
                            const newTrigger = document.querySelector( morePostsTrigger );
                            if ( newTrigger ) {
                                newTrigger.querySelector('a')?.removeAttribute('data-listener-attached');
                                getTaxPostMarkupByTermId( morePostsTrigger, elToReplaceWithPosts, taxonomy, taxonomyTerm, ++page, categoryName );
                            }
                        }, 200);
                    } else {
                        trigger.remove();
                    }

                    if ( typeof awUpdateArticleTimeOnCategoryPage === 'function' ) {
                        awUpdateArticleTimeOnCategoryPage();
                    }
                })
                .catch( err => {
                    console.error('Error loading more posts:', err);
                    anchor.innerHTML = btnOriginalHtml;
                });
        }, { once: true } );
    };
    
    // Start initialization
    tryInitialize();
}




/**
 *
 * @param taxonomy
 * @param taxonomyTerm
 * @param page
 * @return {Promise<any>}
 */
async function getTaxonomyPostMarkupApiCall( taxonomy, taxonomyTerm, page = 1, categoryName = null ) {
    
    // Build URL based on taxonomy type
    let url;
    if ( taxonomy === 'contributor' ) {
        url = `${window.location.origin}/wp-json/adw-post/v1/post-index-markup/contributor/${taxonomyTerm}?page=${page}`;
        if ( categoryName ) {
            url += `&categoryName=${categoryName}`;
        }
    } else {
        url = `${window.location.origin}/wp-json/adw-post/v1/post-index-markup/${taxonomy}/${taxonomyTerm}?page=${page}`;
        if ( categoryName ) {
            url += `&categoryName=${categoryName}`;
        }
    }

    const response = await fetch(url);
    if (response.status !== 200) {
        return { posts: [], is_last_page: true };
    }
    
    const data = await response.json();
    if ( Array.isArray( data ) ) {
        return { posts: data, is_last_page: false };
    }
    
    if ( !data || typeof data !== 'object' ) {
        return { posts: [], is_last_page: true };
    }
    
    if ( !Array.isArray( data.posts ) ) {
        data.posts = [];
    }
    
    if ( data.posts.length === 0 ) {
        data.is_last_page = true;
    }
    
    return data;
}
